import {
  HTTP_STATUS,
  API_RESPONSE,
  CODE_TIMEOUT,
  UNKNOWN_ERROR,
  ERROR_CODES,
} from './_const';

import { useDialogHandler } from './_dialogHandler';

/**
 * Handle error from api
 * @param error error from response
 * @param requestTimes number of request times
 * @param requestTimesLimit limit of request times
 */
export default ({
  error,
  requestTimes,
  requestTimesLimit,
  dialogHandler,
  shouldReturnCode,
  noDialog,
}) => {
  let errorResponse;

  const dialog = useDialogHandler(dialogHandler);

  if (error && error.code === CODE_TIMEOUT) {
    if (
      (!requestTimesLimit || requestTimes === requestTimesLimit - 1) &&
      !noDialog
    ) {
      dialog.openAlert({
        message:
          '您好，抓取資料時發生問題，請檢查網路連線狀況並再試一次，謝謝。',
        replaceTo: '/',
      });
    }
    errorResponse = {
      code: CODE_TIMEOUT,
      message: 'Api timeout',
    };
    return errorResponse;
  }

  if (
    !error ||
    !error.status ||
    error.status !== HTTP_STATUS.OK ||
    !error.data ||
    (shouldReturnCode && !error.data.code)
  ) {
    const errorDetail = JSON.parse(JSON.stringify(error));

    console.error(
      `${
        errorDetail && errorDetail.config ? errorDetail.config.url : ''
      } API Error:`,
      errorDetail.data,
      errorDetail
    );

    if (!noDialog) {
      dialog.openAlert({
        message:
          '系統發生了一些錯誤或者正在維護，請稍後再試一次，或者聯繫客服，謝謝。',
        replaceTo: '/',
      });
    }

    errorResponse = {
      code: UNKNOWN_ERROR,
      message: UNKNOWN_ERROR,
    };
    return errorResponse;
  }

  if (ERROR_CODES.includes(error.data.code)) {
    if (!noDialog) {
      dialog.openAlert({
        message: `系統發生了一些錯誤或者正在維護，請稍後再試一次，或者聯繫客服，謝謝。(錯誤代碼: ${error.data.code})`,
        replaceTo: '/',
      });
    }

    return error.data;
  }

  errorResponse = error.data
    ? {
        code: error.data.code || API_RESPONSE.UNDEFINED_ERROR,
        message:
          error.data.message ||
          '系統發生了一些錯誤或者正在維護，請稍後再試一次，或者聯繫客服，謝謝。',
      }
    : {
        code: API_RESPONSE.UNDEFINED_ERROR,
        message:
          '系統發生了一些錯誤或者正在維護，請稍後再試一次，或者聯繫客服，謝謝。',
      };

  return errorResponse;
};
